import "mediaelement";
import "mediaelement/src/js/languages/de";
import "mediaelement-plugins-custom-akme/dist/a11y/a11y-i18n";
import "mediaelement-plugins-custom-akme/dist/a11y/a11y";
import "bootstrap/js/dist/modal";

var VideoPlayer = (() => {

    class AMVideoPlayer {
        constructor(element) {
            this.element = element;
            this.settings = {
                mejs: {
                    features: [
                        "current",
                        "progress",
                        "duration",
                        "playpause",
                        "tracks",
                        "a11y",
                        "volume",
                        "fullscreen",
                    ],
                    toggleCaptionsButtonWhenOnlyOne: true
                }
            };

            this.player = {
                mejs: null,
                video: this.element.querySelector("video"),
                captioncontrolsBtn: null,
                captioncontrolsInput: null,
                captions: null,
                audiodescription: null,
                videodescription: null,
                modal: null,
                playBtn: null,
                suggestions: null,
                fullscreenBtn: null,
                fullscreenActive: false,
                replayBtn: null,
            };

            this.videoTrackingName = this.element.getAttribute("stylelabs-id") || "videotracking-name-missing";

            this.state = {
                hadTimeSliderInteraction: false,
                trackingKeysToFireOnceOnly: {
                    [TrackingKeys.VIDEO_25_PERCENT]: false,
                    [TrackingKeys.VIDEO_50_PERCENT]: false,
                    [TrackingKeys.VIDEO_75_PERCENT]: false,
                    [TrackingKeys.VIDEO_FULL]: false,
                    [TrackingKeys.VIDEO_WATCHED_10_SEC]: false,
                    [TrackingKeys.VIDEO_WATCHED_30_SEC]: false,
                    [TrackingKeys.VIDEO_WATCHED_60_SEC]: false,
                    [TrackingKeys.VIDEO_WATCHED_1_MIN_30_SEC]: false,
                },
                ignoreNextTwoConsecutivePlayingEventsForTracking: false,
                ignoredPlayingEventsCount: 0,
                playCount: 0,
                currentTime: 10,
                firstTimePlayVideo: true
            };

            this.displayVideo();
        }

        bindEvents() {
            var that = this;

            this.player.suggestions = this.player.suggestions || $(this.element).find(".videoPlayer__suggestions");
            this.player.captioncontrolsBtn = this.player.captioncontrolsBtn || $(this.element).find(".mejs__captions-button");
            this.player.captioncontrolsInput = this.player.captioncontrolsInput || $(this.element).find(".mejs__captions-selector-list input");
            this.player.fullscreenBtn = this.player.fullscreenBtn || $(this.element).find(".mejs__fullscreen-button");
            this.player.replayBtn = this.player.replayBtn || $(this.element).find(".videoPlayer--replay");

            if (this.player.replayBtn) {
                this.player.replayBtn.on('click', () => {
                    if (this.player.fullscreenActive) {
                        this.player.fullscreenBtn.click();
                    }
                });
            }

            if (this.player.fullscreenBtn) {
                this.player.fullscreenBtn.on('click', () => {
                    if ($(this.element).find(".mejs__container-fullscreen").length > 0) {
                        this.player.fullscreenActive = true;
                    }
                    else {
                        this.player.fullscreenActive = false;
                    }
                });
            }

            this.player.mejs.node.addEventListener("ended", () => {
                this.displaySuggestions();
            }, {
                once: true,
            });

            //Remove Tabstob from hidden Captions input
            if (this.player.captioncontrolsInput) {
                this.player.captioncontrolsInput.attr("tabindex", "-1");
            }

            this.player.captioncontrolsBtn.on("keydown", e => {
                if (e.which === 13) {
                    e.preventDefault();
                    this.player.captioncontrolsBtn.trigger("click");
                }
            });

            if ($(this.element).hasClass("videoPlayer__modal--active")) {
                this.handleModal();
            }

            const remotePlayEl = document.querySelector('[mejs-remote-play="' + this.player.mejs.media.id + '"]');

            if (remotePlayEl) {
                $(remotePlayEl).click("click", () => {
                    this.player.mejs.play();
                });
            }

            $(window).on("resize", function () {
                that.adjustPlayerHeight(that.element);
            });

            that.adjustPlayerHeight(that.element);


            document.addEventListener('fullscreenchange', (e) => {
                if ($(this.element).find(".mejs__container-fullscreen").length > 0) {
                    this.player.fullscreenActive = false;
                }
            });

            document.addEventListener('webkitfullscreenchange', (e) => {
                if ($(this.element).find(".mejs__container-fullscreen").length > 0) {
                    this.player.fullscreenActive = false;
                }
            });

            document.addEventListener('mozfullscreenchange', (e) => {
                if ($(this.element).find(".mejs__container-fullscreen").length > 0) {
                    this.player.fullscreenActive = false;
                }
            });

            document.addEventListener('MSFullscreenChange', (e) => {
                if ($(this.element).find(".mejs__container-fullscreen").length > 0) {
                    this.player.fullscreenActive = false;
                }
            });
        }

        /**
         * Adjusts the video player size if the controls are displayed in two rows.
         * Needs to call after a resize event happened to calculate the new height of the video.
         * Video player height is always the height of the player itself because the controls are usually inside the video (overlayed)
         * This function is only because two row'd controls are spaned over the actual video player height. :(
         * @param {any} element
         * <remarks>
         * This code must be the same as in the solution of the lightbox project lightbox.js !!!
         * Workaround because we have not access between both projects
         * </remarks>
         */
        adjustPlayerHeight(element) {
            window.setTimeout(function () {
                var controls = element.querySelector(".mejs__controls");
                var videoContainer = element.querySelector(".videoPlayer__video");
                var style = null;

                if (window.getComputedStyle) {
                    style = getComputedStyle(controls, null);
                } else {
                    style = controls.currentStyle;
                }

                var bottomVal = parseFloat(style.bottom);
                var heightVal = parseFloat(style.height);

                if (bottomVal > 0 && !isNaN(heightVal)) {
                    /* Set height on video container - previously we set the value on the element but then it conflicted with the parent margin (was ignored) */
                    videoContainer.style.marginBottom = (heightVal - bottomVal) + "px";
                } else {
                    videoContainer.style.removeProperty("margin-bottom");
                }
            }, 500); /* Timeout is only for the case: Fullscreen --> Press ESC - Weird behavior without a delay (wrong height) */
        }

        throttled(limit, callback) {
            var waiting = false;
            return function () {
                if (!waiting) {
                    callback.apply(this, arguments);
                    waiting = true;
                    setTimeout(function () {
                        waiting = false;
                    }, limit);
                }
            };
        }

        detectTouch() {
            return (("ontouchstart" in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0));
        }

        displayVideo(startPlayback = false) {
            //eslint-disable-next-line
            mejs.i18n.language("de"); // Setting German language
            //eslint-disable-next-line
            this.player.mejs = new MediaElementPlayer(this.player.video, this.settings.mejs);

            $(this.element).removeClass("ended");

            if (startPlayback) {
                this.player.mejs.play();
            }

            if (this.player.mejs.node) {
                const timeSliderDownEventType = this.detectTouch() ? "touchstart" : "mousedown";
                this.player.mejs.node.addEventListener(timeSliderDownEventType, () => {
                    this.state.hadTimeSliderInteraction = true;
                });

                const timeSliderUpEventType = this.detectTouch() ? "touchend" : "mouseup";
                this.player.mejs.node.addEventListener(timeSliderUpEventType, () => {
                    // Use setTimout here, because mobile browsers trigger the pause event twice after touchstart!
                    window.setTimeout(() => {
                        this.state.hadTimeSliderInteraction = false;
                    }, 500);
                });

                this.player.mejs.node.addEventListener("playing", () => {
                    if (this.state.hadTimeSliderInteraction) {
                        this.state.hadTimeSliderInteraction = false;
                    } else {
                        handlePlayingEventTracking();
                        this.state.isPaused = false;
                    }
                });

                this.player.mejs.node.addEventListener("pause", () => {
                    if (!this.state.hadTimeSliderInteraction) {
                        if (this.player.currentTime < this.player.video.duration) {
                            this.trackEvent(TrackingKeys.VIDEO_PAUSE);
                        }
                        this.state.isPaused = true;
                    }
                });

                const handlePlayingEventTracking = () => {
                    if (this.state.ignoreNextTwoConsecutivePlayingEventsForTracking && !this.state.firstTimePlayVideo) {
                        this.state.ignoredPlayingEventsCount++;
                        if (this.state.ignoredPlayingEventsCount === 2) {
                            this.state.ignoreNextTwoConsecutivePlayingEventsForTracking = false;
                            this.state.ignoredPlayingEventsCount = 0;
                        }
                    } else {
                        if (this.state.isPaused) {
                            this.trackEvent(TrackingKeys.VIDEO_CONTINUE);
                        } else {
                            //this.trackEvent(TrackingKeys.VIDEO_PLAY);
                            this.state.playCount = this.state.playCount + 1;
                            this.state.firstTimePlayVideo = false;
                            this.trackEvent(TrackingKeys.VIDEO_PLAY_COUNT + this.state.playCount);
                        }
                    }
                };

                const timeUpdateHandler = () => {
                    if (this.player.video.duration) {
                        const percent = parseInt((100 / this.player.video.duration) * this.player.video.currentTime);
                        if (percent >= 99) {
                            this.trackEvent(TrackingKeys.VIDEO_FULL);
                        } else if (this.player.video.currentTime > this.state.currentTime) {
                            this.trackEvent("video_" + this.state.currentTime + "sek_gesehen");
                            this.state.currentTime = this.state.currentTime == 10 ?
                                this.state.currentTime = this.state.currentTime + 20
                                : this.state.currentTime = this.state.currentTime + 30;
                        }
                    }
                };

                const tTimeUpdateHandler = this.throttled(1000, timeUpdateHandler);
                this.player.mejs.node.addEventListener("timeupdate", tTimeUpdateHandler);

                // set duration in ms from attributes
                if (this.player.video.dataset.durationMs &&
                    this.player.video.dataset.durationMs > 0) {
                    var durationS = this.player.video.dataset.durationMs / 1000;

                    if (durationS > 0) {
                        var minutes = Math.floor(durationS / 60);
                        var seconds = Math.floor(durationS - 60 * minutes);
                        this.element.querySelector('.mejs__duration').innerText = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
                    }
                }

                this.player.captionsButton = this.player.captions || $(this.element).find(".mejs__captions-button");
                this.player.videoDescriptionButton = this.player.videodescription || $(this.element).find(".mejs__video-description-button");
                this.player.audioDescriptionButton = this.player.audiodescription || $(this.element).find(".mejs__audio-description-button");
                // Tracking UI clicks:
                if (this.player.captionsButton) {
                    this.player.captionsButton.on("click", () => {
                        if (this.player.captionsButton[0].classList.contains("mejs__captions-enabled")) {
                            this.trackEvent(TrackingKeys.VIDEO_CAPTIONS_ON);
                        } else {
                            this.trackEvent(TrackingKeys.VIDEO_CAPTIONS_OFF);
                        }
                    });
                }

                if (this.player.audioDescriptionButton) {
                    this.player.audioDescriptionButton.on("click", () => {
                        if (this.player.audioDescriptionButton[0].classList.contains("audio-description-on")) {
                            this.trackEvent(TrackingKeys.VIDEO_AUDIO_DESCRIPTION_ON);
                        } else {
                            this.trackEvent(TrackingKeys.VIDEO_AUDIO_DESCRIPTION_OFF);
                        }
                    });
                }

                if (this.player.videoDescriptionButton) {
                    this.player.videoDescriptionButton.on("click", () => {
                        // MediaElement triggers two consecutive "playing" events after changing source to DGS-video while in Playing-State, set flag to handle accordingly in tracking event-handler:
                        if (!this.state.isPaused) {
                            this.state.ignoreNextTwoConsecutivePlayingEventsForTracking = true;
                        }

                        if (this.player.videoDescriptionButton[0].classList.contains("video-description-on")) {
                            this.trackEvent(TrackingKeys.VIDEO_VIDEO_DESCRIPTION_ON);
                        } else {
                            this.trackEvent(TrackingKeys.VIDEO_VIDEO_DESCRIPTION_OFF);
                        }
                    });
                }
            }

            // Set the poster attribute manually to prevent double loaded thumbnail images
            var videoTag = $(this.element).find('video');

            if (videoTag) {
                videoTag.attr('poster', videoTag.attr('data-poster'))
            }

            this.bindEvents();
        }

        /*
         * Die Methode trackEvent() fÃ¼hrt das eigentliche Tracking aus und setzt das Config-Objekt mit den Tracking Parametern zusammen.
         * ZusÃ¤tzlich wird geprÃ¼ft, ob der Ã¼bergebene Key Ã¼berhaupt (nochmals) getrackt werden darf.
         */

        trackEvent(key) {
            if (this.trackingKeyIsAllowedToFire(key)) {
                if (utag != undefined) {
                    utag.link &&
                        utag.link({
                            event_id: "video_namen_" + this.videoTrackingName,
                            event_id2: key,
                            etracker_event_action: "video",
                        });
                }
            }
        }

        /*
         * Die Methode trackingKeyIsAllowedToFire() Ã¼berprÃ¼ft, ob der Ã¼bergebene Key (nochmals) getrackt werden darf.
         */

        trackingKeyIsAllowedToFire(key) {
            if (hasOwnProperty.call(this.state.trackingKeysToFireOnceOnly, key)) {
                if (this.state.trackingKeysToFireOnceOnly[key]) {
                    return false;
                } else {
                    this.state.trackingKeysToFireOnceOnly[key] = true;
                    return true;
                }
            } else {
                return true;
            }
        }

        // ...

        displaySuggestions() {
            this.player.suggestions.removeClass("videoPlayer__suggestions--hide");
            $(this.element).addClass("ended");
            $(this.player.suggestions).find(".videoPlayer--replay").one("click", () => {
                this.player.suggestions.addClass("videoPlayer__suggestions--hide");
                this.displayVideo(true);
            });

            if ($(this.element).find(".mejs__container-fullscreen").length > 0) {
                this.player.fullscreenBtn.click();
                this.player.fullscreenActive = true;
            }
        }

        handleModal() {
            this.player.modal = this.player.modal || $(this.element).closest(".videoTeaser__modal");
            this.player.playBtn = this.player.playBtn || $(this.element).find(".mejs__overlay-button");
            this.player.captions = this.player.captions || $(this.element).find(".mejs__captions-button");
            this.player.audiodescription = this.player.audiodescription || $(this.element).find(".mejs__audio-description-button");
            this.player.videodescription = this.player.videodescription || $(this.element).find(".mejs__video-description-button");

            this.player.modal.on("shown.bs.modal", () => {
                this.player.playBtn.focus();
            }).on("hide.bs.modal", () => {
                if (this.player.captions.hasClass("mejs__captions-enabled")) {
                    this.player.captions.trigger("click");
                }
                if (this.player.audiodescription.hasClass("audio-description-on")) {
                    this.player.audiodescription.trigger("click");
                }
                if (this.player.videodescription.hasClass("video-description-on")) {
                    this.player.videodescription.trigger("click");
                }
                this.player.mejs.pause();
                this.player.mejs.setCurrentTime(0);
                this.player.mejs.setVolume(1);
                this.player.mejs.setMuted(false);
            });
        }
    }

    function init() {
        $players = $("[data-js-videoplayer]");

        $.each($players, (i, element) => new AMVideoPlayer(element));
    }

    var $players;

    return {
        init: init,
    };

})();

class TrackingKeys {
    static get VIDEO_PLAY() { return "video_play"; }
    static get VIDEO_PLAY_COUNT() { return "video_play_"; }
    static get VIDEO_PAUSE() { return "video_pause"; }
    static get VIDEO_CONTINUE() { return "video_weiter"; }
    static get VIDEO_FORWARD_REWIND() { return "video_spulen"; }
    static get VIDEO_REPLAY() { return "video_erneut_ansehen"; }

    static get VIDEO_FULLSCREEN_ON() { return "video_vollbild_on"; }
    static get VIDEO_FULLSCREEN_OFF() { return "video_vollbild_off"; }
    static get VIDEO_CAPTIONS_ON() { return "video_untertitel_on"; }
    static get VIDEO_CAPTIONS_OFF() { return "video_untertitel_off"; }
    static get VIDEO_AUDIO_DESCRIPTION_ON() { return "video_vorlesen_on"; }
    static get VIDEO_AUDIO_DESCRIPTION_OFF() { return "video_vorlesen_off"; }
    static get VIDEO_VIDEO_DESCRIPTION_ON() { return "video_dgs_on"; }
    static get VIDEO_VIDEO_DESCRIPTION_OFF() { return "video_dgs_off"; }
    static get VIDEO_MUTE_ON() { return "video_stumm_on"; }
    static get VIDEO_MUTE_OFF() { return "video_stumm_off"; }

    static get VIDEO_25_PERCENT() { return "video_25%"; }
    static get VIDEO_50_PERCENT() { return "video_50%"; }
    static get VIDEO_75_PERCENT() { return "video_75%"; }
    static get VIDEO_FULL() { return "video_full"; }
    static get VIDEO_WATCHED_10_SEC() { return "video_10sek_gesehen"; }
    static get VIDEO_WATCHED_30_SEC() { return "video_30sek_gesehen"; }
    static get VIDEO_WATCHED_60_SEC() { return "video_60sek_gesehen"; }
    static get VIDEO_WATCHED_1_MIN_30_SEC() { return "video_1min_30sek_gesehen"; }

    static get VIDEO_SHARER_FACEBOOK() { return "video_teilen_facebook"; }
    static get VIDEO_SHARER_TWITTER() { return "video_teilen_twitter"; }
    static get VIDEO_SHARER_MAIL() { return "video_teilen_mail-formular"; }
}

export { VideoPlayer };
